<script lang="ts" setup>
import { useAppStore } from "@/store/modules/app";
import { useDesign } from "@/hooks/web/useDesign";
import routerSearch from "@/components/RouterSearch/index.vue";
const message = useMessage(); // 消息弹窗
defineOptions({ name: "APP" });

const { getPrefixCls } = useDesign();
const prefixCls = getPrefixCls("app");
const appStore = useAppStore();
const currentSize = computed(() => appStore.getCurrentSize);
const greyMode = computed(() => appStore.getGreyMode);
import { useVersionCheck } from "@/hooks/app/versionCheck";
import { useUserStore } from "@/store/modules/user";
import { UpgradeNoticeDialog } from "@/components/UpgradeNoticeDialog";
import { ErrorDetailDialog } from "@/components/ErrorDetailDialog";

// 使用版本检测
const { start: startVersionCheck } = useVersionCheck({
  checkInterval: 30 * 1000, // 30秒检测一次
  enableInDev: false, // 开发环境不检测
});

const handleStorageChange = (e: StorageEvent) => {
  if (e.key === "ACCESS_TOKEN" && e.newValue !== e.oldValue) {
    const userStore = useUserStore();
    if (!e.newValue) {
      // 其他页签退出了登录
      userStore.resetState();
    }
    // 其他页签登录或切换了用户，刷新当前页签以同步新用户
    window.location.reload();
  }
};

onMounted(() => {
  startVersionCheck(); // 组件挂载后开始版本检测
  window.addEventListener("storage", handleStorageChange);
});

onBeforeUnmount(() => {
  window.removeEventListener("storage", handleStorageChange);
});
</script>
<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
    <routerSearch />
    <UpgradeNoticeDialog />
    <ErrorDetailDialog />
  </ConfigGlobal>
</template>
<style lang="scss">
$prefix-cls: #{$namespace}-app;

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  @extend .size;

  padding: 0 !important;
  margin: 0;
  overflow: hidden;

  #app {
    @extend .size;
  }
}

.#{$prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
/*.el-notification{
  top: 30% !important;
  left: 50%;
  transform: translate(-50%, -50%);
}*/
</style>
